import { InsightsFilter, InsightsMetricOperationV2 } from '@magicbrief/common';
import { useFormContext } from 'react-hook-form';
import {
  SelectButton,
  Select,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@magicbrief/ui/src/components/select';
import { getOperationsAndLabelsForField } from 'src/pages/Insights/util/insightsFilterOperations';
import ChevronDown from 'src/assets/svgicons/duocolor/chevron-down.svg';

type InsightsFormFilterMetricOperationSelectProps = {
  prefix: string;
  platform: 'facebook' | 'tiktok';
  onChange: (operation: string) => void;
  error?: string | undefined;
};

export const InsightsFormFilterMetricOperationSelect: React.FC<
  InsightsFormFilterMetricOperationSelectProps
> = ({ prefix, onChange, error, platform }) => {
  const { watch } = useFormContext();
  const rootValue: InsightsFilter = watch(prefix);

  return (
    <InsightsFilterMetricOperationSelect
      platform={platform}
      field={rootValue.field}
      value={rootValue.operation}
      onChange={onChange}
      error={error}
    />
  );
};

type InsightsFilterMetricOperationSelectProps = {
  field: string;
  platform: 'facebook' | 'tiktok';
  value?: InsightsMetricOperationV2;
  onChange: (operation: string) => void;
  error?: string | undefined;
};

export const InsightsFilterMetricOperationSelect: React.FC<
  InsightsFilterMetricOperationSelectProps
> = ({ field, onChange, value, platform }) => {
  const { options, labels } = getOperationsAndLabelsForField(platform, field);

  return (
    <Select
      className="flex-1"
      aria-label="select metric operation"
      defaultSelectedKey={value}
      onSelectionChange={(selection) => onChange(selection as string)}
    >
      <SelectButton>
        <SelectValue className="text-ellipsis" />
        <ChevronDown className="size-4 text-primary/50" />
      </SelectButton>
      <SelectContent
        popoverClassName="min-w-[--trigger-width] w-fit"
        items={options.map((opt) => ({
          id: opt,
          name: labels[opt as keyof typeof labels],
        }))}
      >
        {(item) => (
          <SelectItem key={`${item.name}-${item.id}`} id={item.id}>
            {item.name}
          </SelectItem>
        )}
      </SelectContent>
    </Select>
  );
};

export default InsightsFormFilterMetricOperationSelect;
